import React from 'react';
import { timeAgo, followupState, daysWithoutContact, formatDateTime, OPEN_STATUSES, possiblyAttended, upcomingAppointment, needsFirstCall } from './config';
import { L, StatusBadge, TemperatureTag, TestTag, ChannelTag } from './ui';

// Tarjeta compacta de un lead. `mode`: 'bandeja' (destaca el tiempo de espera) o 'cartera'
// (destaca el seguimiento). `actions` se pinta abajo (botones de coger / asignar).
export default function LeadCard({ lead, mode, stock, ownerName, onOpen, actions }) {
  const fu = followupState(lead);
  const days = daysWithoutContact(lead);
  const open = OPEN_STATUSES.includes(lead.status);
  const appt = upcomingAppointment(lead);
  const waitingMin = Math.round((Date.now() - new Date(lead.received_at).getTime()) / 60000);
  const waitColor = waitingMin > 30 ? 'var(--t-f87171)' : waitingMin > 10 ? 'var(--t-fbbf24)' : 'var(--t-4ade80)';

  return (
    <div style={L.card}>
      <button
        type="button"
        onClick={onOpen}
        style={{ background: 'none', border: 'none', padding: 0, textAlign: 'left', cursor: 'pointer', display: 'grid', gap: '6px', color: 'inherit', width: '100%' }}
        aria-label={`Abrir lead de ${lead.customer_name}`}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <strong style={{ color: 'var(--t-f1f5f9)', fontSize: '0.95rem' }}>{lead.customer_name}</strong>
          <ChannelTag channel={lead.channel} />
          {lead.is_test && <TestTag />}
          <span style={{ marginLeft: 'auto' }}><StatusBadge status={lead.status} /></span>
        </div>
        <div style={{ color: 'var(--t-cbd5e1)', fontSize: '0.85rem' }}>
          🚗 {lead.vehicle_text || 'Sin coche indicado'}
          {lead.vehicle_plate ? ` · ${lead.vehicle_plate}` : ''}
          {stock ? <span style={{ color: 'var(--t-93c5fd)' }}> · {stock}</span> : ''}
        </div>
        {open && possiblyAttended(lead) && (
          <div style={{ color: 'var(--t-fbbf24)', fontSize: '0.8rem', fontWeight: 600 }}>
            ⚠️ Posible lead ya atendido · creado en el CRM por {lead.crm_originator}
          </div>
        )}
        {appt && (
          <div style={{ color: 'var(--t-c4b5fd)', fontSize: '0.8rem', fontWeight: 600 }}>
            📅 Cita {appt.toLocaleString('es-ES', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
          </div>
        )}
        {open && lead.assigned_to && !lead.first_contact_at && needsFirstCall(lead) && mode !== 'bandeja' && (
          <div style={{ color: 'var(--t-fbbf24)', fontSize: '0.8rem', fontWeight: 600 }}>📞 Primera llamada pendiente</div>
        )}
        {lead.status === 'descartado' && lead.discard_reason && (
          <div style={{ color: 'var(--t-9ca3af)', fontSize: '0.8rem' }}>🗑️ {lead.discard_reason}</div>
        )}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 12px', alignItems: 'center', fontSize: '0.78rem', color: 'var(--t-9ca3af)' }}>
          {mode === 'bandeja' ? (
            <span style={{ color: waitColor, fontWeight: 600 }}>⏱️ Entró {timeAgo(lead.received_at)}</span>
          ) : (
            <>
              <span style={{ color: fu.color, fontWeight: 600 }}>● {fu.label}</span>
              {open && lead.last_contact_at && days != null && <span>{days === 0 ? 'Contacto hoy' : `${days} día${days === 1 ? '' : 's'} sin contacto`}</span>}
            </>
          )}
          <TemperatureTag temperature={lead.temperature} />
          {ownerName && <span>👤 {ownerName}</span>}
          {mode === 'bandeja' ? <span>{formatDateTime(lead.received_at)}</span> : <span>📥 Entró {formatDateTime(lead.received_at)}</span>}
        </div>
      </button>
      {actions && <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>{actions}</div>}
    </div>
  );
}
